import { all } from "redux-saga/effects";

import { sagas as accidentsSagas } from './accidents';
import { sagas as reportsSagas } from './reports';
import { sagas as departmentSagas } from './departments';
import { sagas as usersSagas } from './users';

export default function* rootSaga() {
    yield all({
        ...accidentsSagas,
        ...reportsSagas,
        ...usersSagas,
        ...departmentSagas,
    });
}